const DEFAULT_RESIDENCE = [4.35, 50.85];

function getFeatureValue(feature) {
  return feature.properties?.id;
}

function getFeatureName(feature) {
  return feature.properties?.name || feature.properties?.municipality;
}

function getFeatureCoordinates(feature) {
  return feature.geometry?.coordinates;
}

function getCount(answerCount, identifiers) {
  return identifiers.reduce((count, identifier) => {
    const nextCount = Number(answerCount?.[identifier] ?? 0);
    return Math.max(count, Number.isFinite(nextCount) ? nextCount : 0);
  }, 0);
}

function makeMunicipalityData(features) {
  const municipalities = new Map();

  features.forEach((feature) => {
    const municipality = feature.properties?.municipality;
    const coordinates = getFeatureCoordinates(feature);

    if (!municipality || !coordinates) return;

    const current = municipalities.get(municipality) || {
      coordinates: [0, 0],
      count: 0,
      name: municipality,
    };

    municipalities.set(municipality, {
      ...current,
      coordinates: [
        current.coordinates[0] + coordinates[0],
        current.coordinates[1] + coordinates[1],
      ],
      count: current.count + 1,
    });
  });

  return [...municipalities.values()].map(municipality => ({
    ...municipality,
    coordinates: municipality.coordinates.map(value => value / municipality.count),
  }));
}

function getAnswerCoordinates(answer) {
  if (!answer || typeof answer !== 'object') return null;

  return answer.coordinates || answer.position || answer.targetCoordinates || null;
}

function getResidenceCoordinates(lastAnswer) {
  return lastAnswer?.answer?.startCoordinates
    || lastAnswer?.answer?.residenceCoordinates
    || DEFAULT_RESIDENCE;
}

function getParticipantResidence(participant) {
  const introduction = participant?.answers?.introduction;

  return {
    name: introduction?.residence,
    coordinates: introduction?.residenceCoordinates
      || participant?.answers?.question2?.residenceCoordinates
      || DEFAULT_RESIDENCE,
  };
}

export {
  getAnswerCoordinates,
  getCount,
  getFeatureCoordinates,
  getFeatureName,
  getFeatureValue,
  getParticipantResidence,
  getResidenceCoordinates,
  makeMunicipalityData,
};
